module.exports = __webpack_public_path__ + "static/img/ship-battleship_256.aede13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship-battleship_256.png
// module id = eRkX
// module chunks = 0